appSocial.component('portfolioCard', {
    templateUrl: 'widgets/portfolio/components/portfolio-card/PortfolioCardComponent.html',
    bindings: {
        trader: '<',
        lastTraderId: '<'
    },
    controller: class PortfolioCardComponent {
        constructor($state,
                    $scope,
                    SocialLocaleService,
                    SocialUtils,
                    SocialActionService,
                    SocialTypes,
                    SocialUserService) {

            this.translation = SocialLocaleService.translation;

            /**
             * @type {SocialUser}
             */
            this.user = SocialUserService.get()

            /**
             * @type {SocialUtils}
             */
            this.utils = SocialUtils;

            /**
             * @type {SocialActionService}
             */
            this.actionService = SocialActionService;

            /**
             * @type {SocialTypes}
             */
            this.types = SocialTypes;

            this.action = this.types.CopyAction;

            this.isLastTrader = false;

            this.$scope = $scope;

            this.contextMenuConfig = {
                top: (menu) => {
                    return 'auto';
                },
                right: (menu) => {
                    return 'auto';
                },
                left: (menu) => {
                    return (menu.portal.offset().left + 15) + 'px';
                },
            }
        }

        $onInit() {
            this.isLastTrader = this.lastTraderId.length && this.trader.id === this.lastTraderId;
        }

        $onChanges(changes) {
        }

        $onDestroy() {
        }

        navigate() {
            this.utils.navigate('root.app.socialLeader', {id: this.trader.id});
        }

        /**
         * @param {CopyAction} action
         */
        callAction(action) {
            return this.actionService.callAction(action, this.trader);
        }
    }
});
